import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Col, DatePicker, Modal, Row, Statistic } from 'antd'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import { useQuery } from '@apollo/react-hooks'
import {
  GET_ALL_NSE_HOLIDAYS,
  TO_SHOW_BROKER_MODAL_POPUP,
} from 'modules/NSEHoliday/graphql/Query'
import Page404 from 'components/Page404'
import './verification.css'
import BookAdvisoryModal from './BookAdvisory/BookAdvisoryModal'
import { AppContext } from 'AppContext'
import client from 'apollo'
import {
  COMPLETE_STEP,
  CREATE_BOOK_ADVISORY,
  GENERATE_ADVISORY,
  COMPLETE_FINSAVER_ONBOARDING,
} from './graphql/Mutations'
import {
  CREATE_ADVISORY_LOG,
  UPDATE_USER,
} from 'modules/Users/graphql/Mutations'
import BookedAdvisorySlotNew from './BookAdvisory/BookedAdvisorySlotNew'
import { GET_ADVISORY_TIME } from 'modules/AdvisoryTime/graphql/Query'
import { uniq } from 'lodash'
import { GET_SP_AUTO_ADVISE, GET_USER_ADDONS } from './graphql/Queries'
import KeyInfo from './KeyInfo'
import calendarIcon from 'assets/images/new-images/calendar.svg'
import { GET_SLOT_BOOKING_SETTING } from 'modules/Settings/graphql/Queries'
import CongratulationsNewImage from 'assets/images/new-images/congratulations.png'
import CongratulationsImage from 'assets/images/new-images/booking.png'
import KycCompletedImage from 'assets/images/new-images/kyc-completed.png'
import HeadsetIconImage from 'assets/images/new-images/headset-icon.png'
import { GET_ALL_NOTIFICATION_FOR_CLIENT } from 'auth/graphql/Queries'
import BrokerModal from 'modules/Addbroker/BrokerModal'
import { CheckCircleFilled } from '@ant-design/icons'

const CongratulationsNew = ({ next, newEdit, isClonedUser: propIsClonedUser }) => {
  const history = useHistory()
  const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const { Countdown } = Statistic
  const [date, setDate] = useState(moment())
  const [openModal, setOpenModal] = useState(false)
  const [isTimeUp, setIsTimeUp] = useState(false)
  const [clientData, setClientData] = useState({})
  const [advisoryLoading, setAdvisoryLoading] = useState(false)
  const [timezone, setTimezone] = useState({})

  const {
    state: { currentUser, isMobile },
    dispatch,
  } = useContext(AppContext)
  const currentUserPlanId = currentUser?.planId || currentUser?.plan?.id

  const { data: userAddonsData } = useQuery(GET_USER_ADDONS, {
    fetchPolicy: 'network-only',
  })
  const isClonedUser =
    Boolean(userAddonsData?.getUserAddons?.parentId) ||
    Boolean(propIsClonedUser)

  const [mandateId, setMandateId] = useState(currentUser?.mandateId)
  const [showSlotBooking, setShowSlotBooking] = useState()
  const [isAdvisoryBooked, setIsAdvisoryBooked] = useState(
    currentUser?.isBookingAdvisoryDateSelected ? true : false,
  )
  const [userData, setUserData] = useState(currentUser)
  const [amcAmount, setAmcAmount] = useState(0)
  const { data, loading, error } = useQuery(GET_ALL_NSE_HOLIDAYS, {
    fetchPolicy: 'network-only',
  })

  const { data: toShowBrokerModalPopup } = useQuery(
    TO_SHOW_BROKER_MODAL_POPUP,
    {
      fetchPolicy: 'network-only',
    },
  )

  useEffect(() => {
    client
      .query({
        query: GET_SLOT_BOOKING_SETTING,
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        setShowSlotBooking(res?.data?.getSlotBookingSetting?.showSlotBooking)
      })
      .catch((err) => {
        console.error(err)
      })
  }, [])
  const [advisoryId, setAdvisoryId] = useState()
  const [isDisableDate, setIsDisableDate] = useState(false)

  const {
    data: advisoryTime,
    loading: advisoryTimeLoading,
    error: advisoryTimeError,
  } = useQuery(GET_ADVISORY_TIME, { fetchPolicy: 'network-only' })

  const planName = currentUser?.plan?.name?.toLowerCase() || ''
  const isFinsaver = planName.includes('finsaver') || planName.includes('conservative') || planName.includes('moderate') || planName.includes('aggressive')

  useEffect(() => {
    setUserData(currentUser)
  }, [currentUser])

  useEffect(() => {
    getSpData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSpData = () => {
    if (!currentUserPlanId) return

    client
      .query({
        query: GET_SP_AUTO_ADVISE,
        variables: {
          where: {
            dontBuyEquity: 'NO',
            exposure: currentUser?.initialExposure,
            planId: parseInt(currentUserPlanId, 10),
            source: 'noLog',
          },
        },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        client
          .query({
            query: GET_ALL_NOTIFICATION_FOR_CLIENT,
            fetchPolicy: 'network-only',
          })
          .then((response) => {
            dispatch({
              type: 'ALL_NOTIFICATIONS_FOR_CLIENT',
              data: response?.data?.getNotifications,
            })
            res.data.spAutoAdvise.forEach((item) => {
              if (Object.keys(item).includes('GrossAMC')) {
                const isAddAuaPath =
                  window?.location?.pathname === '/add-aua-verification'
                const isEligibleForDiscount =
                  (!currentUser?.umrnNumber ||
                    !currentUser?.isFirstAdvisoryTaken) &&
                  currentUser?.completedSteps === 'E_MANDATE' &&
                  !currentUser?.isNewAuaAdvisoryGenerate &&
                  !isClonedUser &&
                  !isAddAuaPath

                if (isEligibleForDiscount) {
                  const eMandateDiscount = item?.GrossAMC * (5 / 100)
                  const finalGrossAmount =
                    item?.GrossAMC - Math.round(eMandateDiscount)
                  let gst = 0
                  if (currentUser?.stateId === 4030) {
                    const cGst = finalGrossAmount * (9 / 100)
                    gst = Math.round(cGst) * 2
                  } else {
                    gst = finalGrossAmount * (18 / 100)
                  }
                  setAmcAmount(Math.round(finalGrossAmount + gst))
                } else {
                  let gst = 0
                  if (currentUser?.stateId === 4030) {
                    const cGst = item?.GrossAMC * (9 / 100)
                    gst = Math.round(cGst) * 2
                  } else {
                    gst = item?.GrossAMC * (18 / 100)
                  }
                  setAmcAmount(item?.GrossAMC + gst)
                }
              }
            })
          })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  let dates = []
  if (!loading && data?.getHoliday.length) {
    dates = data?.getHoliday?.map((item) => item?.date)
  }

  useEffect(() => {
    const current = momentTimezone().tz(currentTimezone)

    const startTime = momentTimezone.tz(
      advisoryTime?.getAdvisoryTime?.startTime,
      'HH:mm:ss',
      'Asia/Kolkata',
    )
    const endTime = momentTimezone.tz(
      advisoryTime?.getAdvisoryTime?.endTime,
      'HH:mm:ss',
      'Asia/Kolkata',
    )
    if (endTime.isBefore(startTime)) {
      endTime.add(1, 'day')
    }

    if (
      (current.day() === 0 ||
        current.day() === 6 ||
        dates.some((date) =>
          momentTimezone.tz(date, currentTimezone).isSame(current, 'day'),
        ) ||
        !moment().isBetween(
          moment(startTime, 'hh:mm A'),
          moment(endTime, 'hh:mm A'),
        )) &&
      showSlotBooking
    ) {
      setIsTimeUp(true)
      setIsDisableDate(true)
    } else {
      setIsDisableDate(false)
      setIsTimeUp(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advisoryTime, currentTimezone, timezone, showSlotBooking])

  let array = []

  const disabledDate = (current) => {
    const isWeekend = current.day() === 0 || current.day() === 6
    const holiday = dates.some((date) => moment(date).isSame(current, 'day'))
    const isToday = current.isSame(moment(), 'day')
    const beforeMarketOpen =
      isToday &&
      current < moment(advisoryTime?.getAdvisoryTime?.startTime, 'hh:mm A')
    const afterMarketClose =
      isToday &&
      current > moment(advisoryTime?.getAdvisoryTime?.endTime, 'hh:mm A')

    if (moment(current) >= moment() && array?.length < 5) {
      if (!holiday && !isWeekend && !beforeMarketOpen && !afterMarketClose) {
        array.push(moment(current).format('DD/MM'))
        array = uniq(array)
      }
    }
    return !array?.includes(moment(current).format('DD/MM'))
  }

  let nextAvailableDate
  const findNextAvailableDate = (currentDate = moment()) => {
    const marketCloseTime = moment(
      advisoryTime?.getAdvisoryTime?.endTime,
      'hh:mm A',
    )

    if (
      (moment(currentDate)?.format('DD-MM-YYYY') ===
        moment()?.format('DD-MM-YYYY') &&
        moment(marketCloseTime).format() <= moment().format()) ||
      // eslint-disable-next-line no-loop-func
      dates.filter((date) => date === currentDate?.format('YYYY-MM-DD'))
        ?.length > 0 ||
      currentDate.day() === 0 ||
      currentDate.day() === 6
    ) {
      currentDate = currentDate.add(1, 'days')
      findNextAvailableDate(currentDate)
    } else {
      nextAvailableDate = moment().format()
    }

    if (nextAvailableDate) return nextAvailableDate
  }

  useEffect(() => {
    if (!advisoryTimeLoading) {
      const startTimeInIST = momentTimezone.tz(
        advisoryTime?.getAdvisoryTime?.startTime,
        'HH:mm:ss',
        'Asia/Kolkata',
      )
      const endTimeInIST = momentTimezone.tz(
        advisoryTime?.getAdvisoryTime?.endTime,
        'HH:mm:ss',
        'Asia/Kolkata',
      )

      const formattedStartTime = startTimeInIST.tz(currentTimezone).format('LT')
      const formattedEndTime = endTimeInIST.tz(currentTimezone).format('LT')

      setTimezone({ startTime: formattedStartTime, endTime: formattedEndTime })
    }
  }, [advisoryTime, currentTimezone, advisoryTimeLoading])

  useEffect(() => {
    if (advisoryTime && !advisoryLoading) {
      const defaultDate = findNextAvailableDate()
      setDate(moment(defaultDate))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advisoryTime, advisoryLoading])

  if (error || advisoryTimeError) return <Page404 />

  const handleDateChange = (e) => {
    setDate(moment(e))
  }

  const openAdvisoryModal = () => {
    setOpenModal(!openModal)
    setClientData({
      name: currentUser?.firstName + ' ' + currentUser?.lastName,
      date: moment(date).format('DD-MM-YYYY'),
    })
    if (
      !date.isBetween(
        moment(timezone.startTime, 'hh:mm A'),
        moment(timezone.endTime, 'hh:mm A'),
      ) &&
      showSlotBooking
    ) {
      setIsTimeUp(true)
    } else {
      setIsTimeUp(false)
    }
  }

  const closeModal = () => {
    setIsTimeUp(false)
    setOpenModal(false)
  }

  const generate = async () => {
    if (!isTimeUp) {
      return client
        .mutate({
          mutation: GENERATE_ADVISORY,
          variables: {
            data: {
              clientCode: currentUser?.clientCode,
              plan: currentUser?.plan?.name,
              exposure: currentUser?.initialExposure,
              initialExposure: currentUser?.initialExposure,
              isNewClient: true,
              source:
                currentUser?.role !== 'CLIENT'
                  ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                  : window?.location?.pathname === '/add-aua-verification'
                  ? 'ADD AUA'
                  : window?.location?.pathname === '/pending-advisory'
                  ? 'Pending Advisory'
                  : 'Onboarding',
            },
          },
        })
        .then((res) => {
          console.log('Advisory Generated')
          return true
        })
        .catch((err) => {
          console.log(err)
          setAdvisoryLoading(false)
          setOpenModal(false)
          return false
        })
    } else {
      return true
    }
  }

  const createAdvisory = async () => {
    setAdvisoryLoading(true)
    generate().then((res) => {
      if (res) {
        client
          .mutate({
            mutation: CREATE_BOOK_ADVISORY,
            variables: {
              data: {
                userId: userData?.id,
                advisoryDate: moment(date).format(),
                isAdvisoryBooked: true,
                isClientLogin: isTimeUp ? false : true,
                isClientAcceptAdvisory: false,
                isTimeUp,
                source:
                  currentUser?.role !== 'CLIENT'
                    ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                    : window?.location?.pathname === '/add-aua-verification'
                    ? 'ADD AUA'
                    : window?.location?.pathname === '/pending-advisory'
                    ? 'Pending Advisory'
                    : 'Onboarding',
              },
            },
          })
          .then((res) => {
            setAdvisoryId(res?.data?.CreateBookAdvisory?.id)
            let data = { isBookingAdvisoryDateSelected: true }
            if (!isTimeUp) {
              if (
                currentUser?.completedSteps === 'DONE' ||
                currentUser?.isNewAuaAdvisoryGenerate
              ) {
                data.newAuaAdvisoryCompletedSteps = 'CONGRATULATION'
              } else {
                data.completedSteps = 'CONGRATULATION'
              }
            } else {
              setIsAdvisoryBooked(true)
            }
            client
              .mutate({
                mutation: UPDATE_USER,
                variables: {
                  data,
                  id: userData?.id,
                },
              })
              .then((response) => {
                client.mutate({
                  mutation: CREATE_ADVISORY_LOG,
                  variables: {
                    data: {
                      userId: userData?.id,
                      clientCode: currentUser?.clientCode,
                      activityType: 'updating user data',
                      activity: 'updating user data',
                      source:
                        currentUser?.role !== 'CLIENT'
                          ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                          : window?.location?.pathname ===
                            '/add-aua-verification'
                          ? 'ADD AUA'
                          : window?.location?.pathname === '/pending-advisory'
                          ? 'Pending Advisory'
                          : 'Onboarding',
                      data: JSON.stringify(data),
                    },
                  },
                })
                setMandateId(response.data.updateUser?.mandateId)
                client
                  .query({
                    query: GET_ALL_NOTIFICATION_FOR_CLIENT,
                    fetchPolicy: 'network-only',
                  })
                  .then((newRes) => {
                    dispatch({
                      type: 'ALL_NOTIFICATIONS_FOR_CLIENT',
                      data: newRes?.data?.getNotifications,
                    })
                    if (!isTimeUp) {
                      client.mutate({
                        mutation: COMPLETE_STEP,
                        variables: {
                          data: {
                            step: 'CONGRATULATION',
                            from: 'WEB',
                          },
                        },
                      })
                      Modal.info({
                        content: (
                          <div
                            style={{
                              display: 'grid',
                              justifyContent: 'center',
                            }}
                          >
                            <div className='info_modal_text'>
                              {'Dear' +
                                ' ' +
                                currentUser?.firstName +
                                ' ' +
                                currentUser?.lastName}
                            </div>
                            <span className='info_modal_text_description'>
                              Please wait for few seconds, we are prcoessing the
                              advisory.
                            </span>
                            <div
                              style={{
                                display: 'grid',
                                justifyContent: 'center',
                              }}
                            >
                              <Countdown
                                className='modal_counter'
                                format='ss'
                                value={Date.now() + 10 * 1000}
                              />
                            </div>
                            <span className='counter_text'>
                              Seconds remaining
                            </span>
                          </div>
                        ),
                        icon: null,
                        centered: true,
                        width: `${isMobile ? '100%' : '40%'}`,
                        okButtonProps: { style: { display: 'none' } },
                      })
                      setTimeout(() => {
                        setUserData(response.data.updateUser)
                        dispatch({
                          type: 'CURRENT_USER',
                          data: response.data.updateUser,
                        })
                        Modal.destroyAll()
                        setAdvisoryLoading(false)
                        setIsTimeUp(false)
                        setOpenModal(false)
                        next()
                      }, 10000)
                    } else {
                      dispatch({
                        type: 'CURRENT_USER',
                        data: response.data.updateUser,
                      })
                      setAdvisoryLoading(false)
                      setIsTimeUp(false)
                      setOpenModal(false)
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                    setAdvisoryLoading(false)
                    setIsTimeUp(false)
                    setOpenModal(false)
                  })
              })
              .catch((error) => {
                client.mutate({
                  mutation: CREATE_ADVISORY_LOG,
                  variables: {
                    data: {
                      userId: userData?.id,
                      clientCode: currentUser?.clientCode,
                      activityType: 'FAILED TO UPDATE USER DATA',
                      activity: 'FAILED TO UPDATE USER DATA',
                      source:
                        currentUser?.role !== 'CLIENT'
                          ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                          : window?.location?.pathname ===
                            '/add-aua-verification'
                          ? 'ADD AUA'
                          : window?.location?.pathname === '/pending-advisory'
                          ? 'Pending Advisory'
                          : 'Onboarding',
                      data: JSON.stringify(data),
                    },
                  },
                })
                console.log(error)
                setAdvisoryLoading(false)
                setIsTimeUp(false)
                setOpenModal(false)
              })
          })
          .catch((err) => {
            console.log(err)
            setIsTimeUp(false)
            setAdvisoryLoading(false)
            setOpenModal(false)
          })
      }
    })
  }

  const submitAdvisory = () => {
    createAdvisory()
  }

  return (
    <>
      {toShowBrokerModalPopup?.toShowBrokerModal && !isFinsaver && (
        <BrokerModal setVisible={toShowBrokerModalPopup?.toShowBrokerModal} />
      )}
      <Row className='row-style'>
        <Col
          lg={
            !currentUser?.isNewAuaAdvisoryGenerate &&
            window.location.pathname === '/verification'
              ? 16
              : 24
          }
          sm={24}
          className={`${
            !currentUser?.isNewAuaAdvisoryGenerate &&
            window.location.pathname === '/verification'
              ? 'col-left disclaimer-col'
              : 'disclaimer-col'
          }? `}
        >
          {(!loading || !advisoryTimeLoading || amcAmount > 0) && (
            <div
              className='congratulations_page'
              style={{
                marginBottom: isMobile ? '10dvh' : '10px',
              }}
            >
              <div>
                {isFinsaver ? (
                  <div style={{ textAlign: 'center', padding: '24px 20px', border: '1px solid #e0e0e0', borderRadius: '16px', margin: '0 auto', backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.02)', width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                      <img src={KycCompletedImage} alt='KYC Completed' style={{ height: 'auto', maxHeight: '180px', objectFit: 'contain' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', fontSize: '28px', fontWeight: 'bold', marginBottom: '4px' }}>
                      <span style={{ color: '#d32f2f' }}>KYC Completed</span>
                      <span style={{ color: '#000' }}>Successfully!</span>
                      <CheckCircleFilled style={{ color: '#d32f2f', fontSize: '24px' }} />
                    </div>
                    <div style={{ fontWeight: '600', fontSize: '16px', color: '#000', marginBottom: '8px' }}>
                      Thank you for completing your KYC verification.
                    </div>
                    <div style={{ color: '#444', fontSize: '15px', marginBottom: '16px' }}>
                      Your KYC has been successfully submitted and verified.
                    </div>

                    <div style={{ 
                      backgroundColor: '#fff9f9', 
                      border: '1px solid #fce8e8', 
                      borderRadius: '12px', 
                      padding: '20px 24px', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      maxWidth: '550px', 
                      margin: '0 auto 16px auto',
                      textAlign: 'left'
                    }}>
                      <div style={{
                        marginRight: '20px',
                        flexShrink: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <img src={HeadsetIconImage} alt='Support' height={52} width={52} />
                      </div>
                      <div style={{ color: '#000', fontSize: '16px', lineHeight: '1.6' }}>
                        <span style={{ fontWeight: '600' }}>Our team will review your details and<br />connect with you within the next <span style={{ color: '#d32f2f' }}>48 hours</span></span>
                        <br /><span style={{ fontWeight: 'normal', color: '#444' }}>to assist you further.</span>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px auto', maxWidth: '250px' }}>
                      <div style={{ flex: 1, height: '1px', backgroundColor: '#ffcccc' }}></div>
                      <div style={{ padding: '0 12px', color: '#d32f2f', fontSize: '18px' }}>♥</div>
                      <div style={{ flex: 1, height: '1px', backgroundColor: '#ffcccc' }}></div>
                    </div>

                    <div style={{ color: '#444', fontSize: '14px', marginBottom: '8px' }}>
                      If you have any questions, please feel free to contact us.
                    </div>
                    <div style={{ color: '#d32f2f', fontWeight: '600', fontSize: '15px', marginBottom: '24px' }}>
                      Thank you for choosing Finideas Investment Advisor Pvt. Ltd.
                    </div>

                    <Button
                      type='primary'
                      style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', width: '220px', height: '44px', fontSize: '16px', fontWeight: '600', borderRadius: '8px' }}
                      loading={advisoryLoading}
                      onClick={() => {
                        setAdvisoryLoading(true)
                        client.mutate({
                          mutation: COMPLETE_FINSAVER_ONBOARDING,
                          variables: {
                            data: {
                              riskProfile: 'Moderate',
                            },
                          },
                        }).then((res) => {
                          const updatedUserData = res?.data?.completeFinsaverOnboarding
                          if (updatedUserData) {
                            dispatch({ type: 'CURRENT_USER', data: { ...currentUser, ...updatedUserData } })
                          }
                          dispatch({ type: 'IS_VERIFICATION_DONE', data: true })
                          history.push('/')
                        }).catch((err) => {
                          console.error('FinSaver completion error:', err)
                          history.push('/')
                        }).finally(() => {
                          setAdvisoryLoading(false)
                        })
                      }}
                    >
                      Done
                    </Button>
                  </div>
                ) : isAdvisoryBooked &&
                userData &&
                userData?.isBookingAdvisoryDateSelected &&
                (userData?.completedSteps !== 'CONGRATULATION' ||
                  userData?.newAuaAdvisoryCompletedSteps !==
                    'CONGRATULATION') ? (
                  <BookedAdvisorySlotNew
                    mandateId={mandateId}
                    amcAmount={amcAmount}
                    dateData={dates}
                    setAdvisoryId={setAdvisoryId}
                    userData={userData}
                    isClonedUser={isClonedUser}
                  />
                ) : (
                  <div
                    style={{
                      height: '100%',
                    }}
                  >
                    <div className='hand-shake-image'>
                      <img
                        src={
                          showSlotBooking
                            ? CongratulationsImage
                            : CongratulationsNewImage
                        }
                        alt='HandShakeImage'
                        // width={350}
                        height={200}
                      />
                    </div>
                    {/* <div className='congratulations_main_div'>
                      <b>*** !!! Congratulations !!! ***</b>
                    </div> */}
                    {/* <div className='congratulations_sub_div'>
                      Thank you for selecting Finideas Investment Advisor
                      Private Limited as your trusted partner for your financial
                      planning journey towards achieving financial freedom
                    </div> */}

                    <div
                      style={{
                        display: 'grid',
                        justifyContent: 'center',
                      }}
                    >
                      <div className='congratulations_main_div'>
                        Would you like to move forward with the advisory?
                        <br />
                      </div>
                      {showSlotBooking && (
                        <>
                          <div className='congratulations_date_select_sub_div'>
                            Kindly select the slot for advisory : &nbsp;
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <DatePicker
                              className='client-detail-date-picker'
                              getPopupContainer={(trigger) =>
                                trigger.parentElement
                              }
                              style={{ width: 'fit-content' }}
                              disabledDate={disabledDate}
                              onChange={handleDateChange}
                              format={'DD-MM-YYYY'}
                              value={date}
                              allowClear={false}
                              dropdownClassName='custom-dropdown-class'
                              suffixIcon={
                                <img src={calendarIcon} alt='calendarIcon' />
                              }
                            />
                          </div>
                        </>
                      )}
                    </div>
                    {(!moment().isBetween(
                      moment(
                        advisoryTime?.getAdvisoryTime?.startTime,
                        'hh:mm A',
                      ),
                      moment(advisoryTime?.getAdvisoryTime?.endTime, 'hh:mm A'),
                    ) ||
                      isDisableDate) &&
                      showSlotBooking && (
                        <div className='congratulations_error_div'>
                          Advisory sessions will only be available from &nbsp;
                          {moment(
                            advisoryTime?.getAdvisoryTime?.startTime,
                            'hh:mm A',
                          ).format('LT')}
                          &nbsp;to &nbsp;
                          {moment(
                            advisoryTime?.getAdvisoryTime?.endTime,
                            'hh:mm A',
                          ).format('LT')}
                          . Please choose a different slot for your advisory
                          session.
                        </div>
                      )}

                    <div className='congratulations_next_btn_div'>
                      <Button
                        // id='btn-click'
                        type='primary'
                        className='yes-next-button'
                        onClick={openAdvisoryModal}
                        style={{
                          width: '130px',
                          marginBottom: isMobile ? '10dvh' : '2px',
                        }}
                      >
                        Next
                      </Button>
                    </div>

                    {openModal && (
                      <BookAdvisoryModal
                        isModalOpen={openModal}
                        onCancel={closeModal}
                        isTimeUp={isTimeUp}
                        data={clientData}
                        onCreate={submitAdvisory}
                        loading={advisoryLoading}
                        advisoryTime={timezone}
                        amcAmount={amcAmount}
                        isMobile={isMobile}
                        isClonedUser={isClonedUser}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </Col>
        {!currentUser?.isNewAuaAdvisoryGenerate &&
          window.location.pathname === '/verification' && (
            <Col lg={8} sm={24} className='col-right'>
              <KeyInfo newEdit={newEdit} advisoryData={{ id: advisoryId }} />
            </Col>
          )}
      </Row>
    </>
  )
}

export default CongratulationsNew
